import React from 'react'
import { Trans } from 'react-i18next'

import IconBtnGo from 'app/components/_Icons/IconBtnGo'
import PlainLinkAsButton from 'app/common/ui-next/plain-link-as-button'

import styles from './CustomFooter.module.scss'

type Props = {
  error?: string
  externalLink?: string
}

export const CustomFooter = ({ error, externalLink }: Props) => (
  <div className={styles.root}>
    <div className={styles.info}>{error}</div>

    <PlainLinkAsButton to={externalLink || ''} disabled={!externalLink}>
      <Trans i18nKey="subs:open_bt">{'Открыть'}</Trans>
      <IconBtnGo className={styles.iconGo} />
    </PlainLinkAsButton>
  </div>
)
